import React from 'react';

import { Check, X } from 'lucide-react';

interface PasswordRequirementsProps {
  validation: {
    length: boolean;
    uppercase: boolean;
    lowercase: boolean;
    digit: boolean;
  };
}

const requirements = [
  { key: 'length',    label: 'At least 6 characters' },
  { key: 'uppercase', label: 'One uppercase letter (A–Z)' },
  { key: 'lowercase', label: 'One lowercase letter (a–z)' },
  { key: 'digit',     label: 'One digit (0–9)' },
] as const;

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ validation }) => (
  <div className="mt-3 bg-[rgba(255,255,255,0.03)] border border-line p-4">
    <p className="cg-label mb-3">Password Requirements</p>
    <ul className="flex flex-col gap-2">
      {requirements.map(({ key, label }) => {
        const met = validation[key];
        return (
          <li key={key} className="flex items-center gap-2">
            <div className={`w-4 h-4 flex items-center justify-center flex-shrink-0 ${met ? 'text-accent' : 'text-[#4E5850]'}`}>
              {met
                ? <Check className="w-3.5 h-3.5" />
                : <X className="w-3.5 h-3.5" />
              }
            </div>
            <span className={`font-['Space_Mono'] text-[10px] ${met ? 'text-accent' : 'text-muted2'}`}>
              {label}
            </span>
          </li>
        );
      })}
    </ul>
  </div>
);

export default PasswordRequirements;
